<div ui-row uiJustify="center">
  <div class="sp-px-12" ui-col>
    <div class="sp-mb-24" ui-row uiJustify="center">
      <div ui-col>
        <i class="main-icon" uiType="no-permissions" uiTheme="fill" ui-icon></i>
      </div>
    </div>
    <div ui-row uiJustify="center">
      <div ui-col>
        <h4 class="title text-color-gray-13 fs-30px">{{ "unable_to_create_key_results" | localize }}</h4>
        <p class="description sp-mt-24 sp-mb-32 text-color-gray-13 fs-14px">{{ "no_permissions_to_create_key_results_contact_admin" | localize }}</p>
      </div>
    </div>
  </div>

  <div>
    <button (click)="dismiss.emit()" (keydown.enter)="dismiss.emit()" ui-button uiDanger="true" uiSize="large" uiType="primary" uiShape="round">{{ "got_it" | localize }}</button>
  </div>
</div>
